import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@material-ui/core';

import messages from '../App/messages';

import './styles.scss';

const states = {
    OPEN: 'open',
    NEXT_IN_LINE: 'nextInLine',
    IN_PREPARATION: 'inPreparation',
    PREPARED: 'prepared',
    PICKED_UP: 'pickedUpWithTime',
    CANCELED: 'canceledWithTime',
};

function OrderStateText({
    orderQueue,
    id,
    state,
    updatedAt,
    pickedUpAt,
    canceledAt,
    locale,
}) {
    let stateClass;
    if (orderQueue && orderQueue[id] && orderQueue[id].position === 1) {
        stateClass = states.NEXT_IN_LINE;
    } else {
        stateClass = states[state];
    }

    const message = messages[stateClass];

    let date;
    let time;
    if (state === 'PICKED_UP') {
        date = moment(pickedUpAt).locale(locale).format('LL');
        time = moment(pickedUpAt).locale(locale).format('LT');
    } else if (state === 'CANCELED') {
        date = moment(canceledAt).locale(locale).format('LL');
        time = moment(canceledAt).locale(locale).format('LT');
    } else {
        date = moment(updatedAt).locale(locale).format('LL');
        time = moment(updatedAt).locale(locale).format('LT');
    }

    return (
        <div className={`order-state-text ${stateClass}`}>
            <Typography variant="body2" align="center" className="order-state-text--inner">
                {message &&
                    <FormattedMessage
                        {...message}
                        values={{ date, time }}
                    />
                }
            </Typography>
        </div>
    );
}

OrderStateText.states = states;

OrderStateText.propTypes = {
    orderQueue: PropTypes.object,
    id: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    updatedAt: PropTypes.string,
    pickedUpAt: PropTypes.string,
    canceledAt: PropTypes.string,
    locale: PropTypes.string.isRequired,
};

OrderStateText.defaultProps = {
    updatedAt: new Date().toISOString(),
};

function mapStateToProps(state) {
    return {
        orderQueue: state.global.orderQueue,
        locale: state.languageProviderReducer.locale,
    };
}

export default connect(mapStateToProps)(OrderStateText);
